import styled from '../../../theme'

const Wrapper = styled.div<{ size?: number }>`
  display: flex;
  align-items: center;
  height: ${({ size }) => (size ? 45 * size : 45)}px;
  background-color: #eff2f5;
  width: 50%;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    width: 100%;
  }
`

export default Wrapper
